import { createElementBlock as e, openBlock as r } from "vue";
import c from "../../_virtual/_plugin-vue_export-helper.js";
const t = {}, o = { class: "header-item-spacer" };
function n(s, a) {
  return r(), e("span", o);
}
const p = /* @__PURE__ */ c(t, [["render", n]]);
export {
  p as default
};
